// Chats Novos //
// Seguro Habitacional
export const chatIdHabitacionalServicos = "573Dn000000ttcj";
export const chatIdHabitacionalAssistencias = "573U50000000lQL";
export const chatIdHabitacionalSinistro = "573U50000000lOj";
// Seguro Residencial
export const chatIdResidencialServicos = "573Dn000000ttcF";
export const chatIdResidencialAssistencias = "573U50000000lRx";
export const chatIdResidencialSinistro = "573U50000000lTZ";
// Seguro Empresarial
export const chatIdEmpresarialServicos = "573U50000000lVB";
export const chatIdEmpresarialAssistencias = "573U50000000lYP";
export const chatIdEmpresarialSinistro = "573U50000000lWn";

// Chats Antigos //
// Consórcios
export const chatIdConsorcio = "57336000000D2xn";
// Capitalização/Cap Aluguel
export const chatIdCapitalizacao = "57336000000D2xX";
